import WorkOrdersContainer from '@components/containers/workOrders';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const WorkOrders: FC = () => (
    <AppLayout>
        <WorkOrdersContainer />
    </AppLayout>
);

export default WorkOrders;
